module.exports = __webpack_public_path__ + "img/graden6.4fc625dc.png";